module.exports = __webpack_public_path__ + "img/5.4f0e05f8.png";